/** Pausa al tipear un nombre antes de aplicar la búsqueda. */
export const BUSQUEDA_NOMBRE_DELAY_MS = 1500;
